import { render } from "./GroupBar.vue?vue&type=template&id=f13cc886&scoped=true"
import script from "./GroupBar.vue?vue&type=script&lang=js"
export * from "./GroupBar.vue?vue&type=script&lang=js"

import "./GroupBar.vue?vue&type=style&index=0&id=f13cc886&scoped=true&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13cc886"]])

export default __exports__